<template>
<div>
    <div class="inner-header ">
        <nav class="navbar fixed-top bg-white animate__animated animate__slideInRight">
            <a @click="$router.go(-1)" class="back-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
                    <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                        <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2" />
                        <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2" />
                    </g>
                </svg>
            </a>
            <a href="javascript:void(0);" class="link-title"> Edit Daily Stand up</a>
        </nav>
    </div>
    <div class="inner-page bg-white animate__animated animate__slideInRight">
        <div class="container-fluid">
            <div class="row">
                <!-- Enquiry Card -->
                <div class="col-12">
                    <div class="card details-card form-card">
                        <div class="card-body p-0">
                            <div class="row">
                                <div class="col-12">
                                    <span class="lead-heading mt-4 mb-4">Enter Meeting Details</span>
                                </div>
                                <div class="col-12">
                                    <b-form @submit.prevent="EditMeetingDetails">
                                        <b-form-group>
                                            <label>Standup Type<span class="text-danger">*</span></label>
                                                <b-form-select :disabled="true" v-model="EditMeeting.stand_up_type" required :options="StandupType">
                                                </b-form-select>
                                            </b-form-group>
                                            <b-form-group v-if="EditMeeting.stand_up_type=='Outdoor Duty'">
                                                <label>Start Time<span class="text-danger">*</span></label>
                                                <datetime  :disabled="true" type="datetime" v-model="EditMeeting.od_start_time" required placeholder="Start Time">
                                                </datetime>
                                            </b-form-group>
                                            <b-form-group v-if="EditMeeting.stand_up_type=='Outdoor Duty'">
                                            <label>End Time<span class="text-danger">*</span></label>
                                                <datetime :disabled="true" type="datetime" v-model="EditMeeting.od_end_time" required placeholder="End Time">
                                                </datetime>
                                            </b-form-group>
                                        <b-form-group class="form-group  mb-4p-0 ">
                                            <label for="firmName">Meeting Target <span class="text-danger"></span></label>
                                            <b-form-input type="number" v-model="EditMeeting.todays_meeting_target" placeholder=""></b-form-input>
                                        </b-form-group>
                                        <!-- <b-form-group>
                                            <label>Enquiry Sourcing Target<span class="text-danger"></span></label>
                                            <b-form-input type="number" v-model="EditMeeting.enquiry_sourcing_target" placeholder=""></b-form-input>
                                        </b-form-group> -->
                                        <b-form-group>
                                            <label>My Sign-in Location<span class="text-danger">*</span></label>
                                            <b-form-input type="text" v-model="EditMeeting.location" disabled readonly required placeholder="Find My Location"></b-form-input>
                                        </b-form-group>
                                        <b-form-group>
                                            <label>Comments<span class="text-danger">*</span></label>
                                            <b-form-textarea placeholder="Comments" required v-model="EditMeeting.comment" rows="3" max-rows="6" minlength="50"></b-form-textarea>
                                        </b-form-group>
                                        <template v-if="!EditMeeting.signing_off_edit_daily_stand_up">
                                        <label >Signing-off<span class="text-danger">*</span></label>
                                        <b-form-checkbox class="signoff-checkbox" type="checkbox" :disabled="isTimeExpired" v-model="sign"></b-form-checkbox>
                                      </template>
                                        <template v-if="sign">
                                            <b-form-group label="">
                                                <CanmeraImageCapture selfiemessage="Sign off" ref="cameraCapture" />
                                            </b-form-group>
                                            <label>Signing-off Location <span class="text-danger">*</span></label>
                                            <b-form-input type="text" v-model="EditMeeting.signing_off_location" disabled readonly required placeholder="Find My Location"></b-form-input>
                                        </template>
                                        <b-form-group class="mt-5">
                                            <b-button variant="primary" type="submit" block>Save</b-button>
                                        </b-form-group>
                                    </b-form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    decodeEditMeetingParams
} from '@/assets/scripts/utility.js';
import {
    Datetime
} from 'vue-datetime';
import Multiselect from 'vue-multiselect'
import { decodeEditDailyMeeting } from '@/assets/scripts/utility.js';

export default {
    name: 'EditMeeting',
    components: {
        datetime: Datetime,
        Multiselect,
        CanmeraImageCapture: () => import('@/components/Forms/CameraImageCapture.vue')
    },
    data() {
        return {
            Campaigns: [],
            DeletedCampaigns: [],
            ProjectList: [],
            EditMeeting: {
                todays_meeting_target: 0,
                enquiry_sourcing_target: 0,
                comment: "",
                location: "",
                signing_off_location: "",
                signing_off_meeting_lat: "",
                signing_off_meeting_long: "",
                signing_off_selfie_photo: "",
                od_start_time:"",
                od_end_time:"",
                stand_up_type:"",
            },
            sign: false,
            showCampaignModel: false,
            meetingTypeListFromMyMeeting: [],
            AddCampaign: {
                start_date: null,
                end_date: null,
                campaign_type: null,
                title: null,
                achieved: null,
                enquiries_count: null,
                building_id: null,
                compaign_data: null,
                comment: null,
                executed: false,
                _destroy: false,
                IUD: 'I',
                isFromMyMeetings: false,
            },
            brokerSelected: {
                id: null,
                name: 'Select Broker'
            },
            GetS3Discussion: [{
                    value: null,
                    text: 'Select One'
                },
                {
                    value: true,
                    text: 'Yes'
                },
                {
                    value: false,
                    text: 'No'
                }
            ],
            isTimeExpired: false,
        }
    },
    mounted() {
        this.getMeetingTypeList();
        this.isFromMyMeetings = JSON.parse(sessionStorage.getItem("isFromMyMeetings"));
        let brokers = []
        this.$store.getters.brokersMaster.forEach(broker => {
            brokers.push({
                id: broker.value,
                name: broker.text
            })
        })
        this.brokers = brokers;
        this.updateFieldRequired();
        this.selectBroker();
        this.GetMeetingDetailsONEdit(this.$route.params.id);
        this.checkIsTimeExpired();
        this.getFiltersData();

    },
    computed: {
        StandupType(){
          return this.$store.getters.standupTypeMaster;
        },
        FieldExecutiveList() {
            return this.$store.getters.FieldExecutiveMaster;
        },
        CamapaignTypes() {
            return this.$store.getters.CampaignTypesMaster;
        },
        firmList() {
            let brokers = []
            this.$store.getters.BrokersFirmNameMaster.forEach(broker => {
                brokers.push({
                    id: broker.value,
                    name: broker.text
                })
            })
            return brokers;
        },
        meetingTypesList() {
            return this.$store.getters.MeetingTypesMaster;
        },
        roleid() {
            return localStorage.getItem('radiate-crm-role_id')
        },
    },
    methods: {
      getCurrentPosition() {
          if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition((position) => {
                  this.EditMeeting.signing_off_meeting_lat = position.coords.latitude;
                  this.EditMeeting.signing_off_meeting_long = position.coords.longitude;
                  this.getStreetAddressFrom(position.coords.latitude, position.coords.longitude);
              }, (error) => {
                  console.log(error);
              }, { timeout: 10000, enableHighAccuracy: true, maximumAge: 0 });
          } else {
              //Geolocation is not supported by this browser
          }
      },
      async getStreetAddressFrom(lat, long) {
          try {
              const { data } = await this.$axios.get(
                  "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
                  lat +
                  "," +
                  long +
                  "&key=AIzaSyCDi6loOYUz1fXzMJpqI_83UlcdPrp86Fg"
              );
              if (data.error_message) {
                  console.log(data.error_message)
              } else {
                console.log(data.results[0].formatted_address,"data.results[0].formatted_address")
                  this.EditMeeting.signing_off_location = data.results[0].formatted_address;
              }
          } catch (error) {
              console.log(error);
          }
      },
      checkIsTimeExpired() {
        let now = new Date();
        let hours = now.getHours();
        let minutes = now.getMinutes() / 100;
        let time = hours + minutes;
        this.isTimeExpired = false;
      },
      getFiltersData() {
        this.$axios.get(`daily_stand_ups/settings`).then((result)=> {
            this.settingsData = result.data;
            this.FieldExecutiveList = this.settingsData.field_executives;
            this.teamLeadList = this.settingsData.team_leads;
        });
    },
        setEndDate(start_date) {
            this.EditMeeting.end_date = start_date
        },
        AddUpdateCampaign(row) {
            if (row === undefined) {
                this.showCampaignModel = true
                this.AddCampaign.IUD = 'I'
            } else if (row.building_id !== null) {
                this.AddCampaign = row
                if (this.AddCampaign.building_id) {
                    this.AddCampaign.building_id = {
                        value: row.building_id,
                        text: row.building_name
                    }
                }
                this.AddCampaign.IUD = 'U'
                this.showCampaignModel = true
            }
        },
        AddNewCampiagn(row) {
            if (row.IUD === 'I') {
                this.Campaigns.push(row)
                this.showCampaignModel = false
                this.AddCampaign = {}
            } else {
                this.showCampaignModel = false
                this.AddCampaign = {}
            }
        },
        DeleteCampaign(row) {
            row._destroy = 1
            this.DeletedCampaigns.push(row)
            this.Campaigns.splice(this.Campaigns.indexOf(row), 1)
        },
        getMeetingTypeList() {
            this.$axios.get("/enquiries/client_meetings/settings", {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((res) => {
                    // this.meetingTypesList = res;
                    for (var i = 0; i < Object.keys(res.data.meeting_types).length; i++) {
                        this.meetingTypeListFromMyMeeting.push({
                            "text": Object.keys(res.data.meeting_types)[i],
                            "value": Object.keys(res.data.meeting_types)[i]
                        })
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        GetMeetingDetailsONEdit(MeetingId) {
            let queryP = {}
            queryP['id'] = MeetingId;
            if (!this.isFromMyMeetings) {
                this.$axios.get(`daily_stand_ups/${queryP.id}/daily_stand_up_detail?id=${queryP.id}`).then((res) => {
                    this.EditMeeting = res.data.daily_stand_up;
                    this.getCurrentPosition();
                    //   this.EditMeeting.user_id = {text:res.data.meeting.username, value:res.data.meeting.user_id};
                    //   this.brokerSelected = {id: res.data.meeting.broker_id, name: res.data.meeting.name_with_firm_name};
                    //   this.updateFieldRequired();
                    //   this.selectBroker();
                    //   this.Campaigns = res.data.campaign_data;
                    //   this.getProjects();
                });
            } else {
                this.$axios.get(`enquiries/client_meetings/${queryP.id}/client_meeting_detail?id=${queryP.id}`).then((res) => {
                    this.EditMeeting = res.data.client_meeting
                    this.EditMeeting.user_id = {
                        text: res.data.client_meeting.field_executive,
                        value: res.data.client_meeting.id
                    };
                    this.brokerSelected = {
                        id: res.data.client_meeting.id,
                        name: res.data.client_meeting.broker_name
                    };
                    // this.EditMeeting.start_date = res.data.client_meeting.start_date_time;
                    // this.EditMeeting.end_date = res.data.client_meeting.end_date_time;
                    // this.updateFieldRequired();
                    // this.selectBroker();
                    // this.Campaigns = res.data.campaign_data;
                    // this.getProjects();
                });
            }
        },
        getProjects() {
            this.ProjectList = []
            let queryP = {}
            queryP['broker_id'] = this.brokerSelected.id
            this.$axios.get(`users/meetings/projects_for_new_campaign`, {
                params: queryP
            }).then((res) => {
                res.data.projects.forEach((item, index) => {
                    this.ProjectList.push({
                        value: item.id,
                        text: item.name
                    })
                });
                this.ProjectList.unshift({
                    value: null,
                    text: 'Select Project'
                })
            });
        },
        EditMeetingDetails() {
            // let apiParams = decodeEditMeetingParams(this.EditMeeting, this.Campaigns);
            if(this.$refs?.cameraCapture?.finalImage || this.sign) {
              this.EditMeeting.signing_off_selfie_photo = this.$refs.cameraCapture.finalImage;
            
              if (!this.EditMeeting.signing_off_selfie_photo) {
                  this.$refs.cameraCapture.checkPhoto = true;
                  return;
              } else {
                  this.$refs.cameraCapture.checkPhoto = false;
              }
            }else {
              delete this.EditMeeting.signing_off_selfie_photo;
            }
            let formData = decodeEditDailyMeeting(this.EditMeeting);
            this.$axios
                .put(`daily_stand_ups/${this.$route.params.id}`, formData)
                .then((res) => {
                    swal({
                        title: "Daily Standup Updated!",
                        icon: "success",
                    }).then(this.$router.replace({
                        name: "DailyStandUpDetails",
                        params: {
                            id: this.$route.params.id
                        }
                    }));
                })
                .catch((err) => {
                    if (err.response.status === 500) {
                        swal({
                            title: "Server Error!",
                            icon: "error",
                        });
                    } else {
                        swal({
                            title: "Error",
                            text: err.response.data.message,
                            icon: "error",
                        });
                    }
                });
        },
        selectBroker() {
            this.$nextTick(() => {
                if (this.$refs.brokerselect) {
                    this.$refs.brokerselect.$el.querySelector('input').required = !this.brokerSelected || !this.brokerSelected.id;
                }
            });
        },
        updateFieldRequired() {
            this.$nextTick(() => {
                this.$refs.multiselect.$el.querySelector('input').required = !this.EditMeeting.user_id || !this.EditMeeting.user_id.value;
            });
        }
    },

}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style><style scoped>
.bgcolor {
    background: #f58321;
    color: white
}

table {
    font-size: 12px;
    font-weight: 400;
}

.btn-white-small {
    padding: 4px 8px;
    background: #fff;
    border: 1px solid #dfdfdf;
    margin-right: 5px;
}

.campaign-comment {
    white-space: pre-line;
}
</style>
